export function Error500() {
  return (
    // <AppLayout>
    <div className="flex flex-1 items-center">
      <h1 className="text-4xl">500</h1>
    </div>
    // </AppLayout>
  );
}
